<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="800px"
    class="assing-work-order-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        ref="form"
      >
        <template v-if="!isTransfer">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$t('asm_assign_work_order_dialog.shgcs')"
                prop="firstPersonId"
              >
                <el-select
                  v-model="form.firstPersonId"
                  filterable
                >
                  <el-option
                    v-for="(item,index) in selFilter(form.secondPersonId)"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('asm_assign_work_order_dialog.shou_hou_zhu_guan')"
                prop="secondPersonId"
              >
                <el-select
                  v-model="form.secondPersonId"
                  filterable
                >
                  <el-option
                    v-for="(item,index) in selFilter(form.firstPersonId)"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$t('asm_assign_work_order_dialog.shou_hou_fu_ze_ren')"
                prop="firstPersonId"
              >
                <el-select v-model="form.firstPersonId">
                  <el-option
                    v-for="(item,index) in tableList"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

      </el-form>
      <div class="conten">
        <div class="item-title">{{$t('asm_assign_work_order_dialog.gcswwcgdhz')}}</div>
        <div class="table-bd">
          <custom-table
            :tableCode="tableCode"
            height="300px"
            @filter="filterChange"
            @sort="sortChange"
            :index="true"
            :data="tableList"
          ></custom-table>
        </div>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 * 分派工单 / 转派工单
 */
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // model: {
    //   data: {
    //     workOrderId: '',
    //     orderDeviceId: '',
    //   }
    // }
    // 是否转派工单
    isTransfer: {
      type: Boolean,
      default: false,
    },
    // 是否返工单
    isRework: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableCode: 'work_order_sales_engineer',
      tableList: [],
      form: {
        firstPersonId: '',
        secondPersonId: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        firstPersonId: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        secondPersonId: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
      };
    },
    filterArr() {
      return this.isRework ? [] : ['countFg'];
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    getTableList() {
      this.$getJSON(apis.WorkOrderTotalTechnicianList, {
        workOrderId: this.model.data.workOrderId,
      }).then((res) => {
        this.tableList = res.data || [];
      });
    },
    selFilter(id) {
      return this.tableList.filter(item => item.userId !== id);
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const reqUrl = this.isTransfer ? apis.WorkOrderOptTransferWork : apis.caseOrderGenerateWorkOrder;
          if (this.model.type === 'redispatch') {
            this.$showConfirm(this.$t('asm_assign_work_order_dialog.nqdyzcfpgcsqjjcalm')).then(() => {
              this.$postJSON(reqUrl, this.getReqData(), true).then(() => {
                this.$message({
                  message: this.$t('Common.com_handle_success'),
                  type: 'success',
                });
                this.closeDialog();
                this.$emit('success');
              });
            });
          } else {
            this.$postJSON(reqUrl, this.getReqData(), true).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.$emit('success');
              this.closeDialog();
            });
          }

        }
      });
    },
    getReqData() {
      if (this.isTransfer) {
        return {
          workOrderId: this.model.data.workOrderId,
          technicianId: this.form.firstPersonId
        };
      }
      const filterIds = this.isTransfer ? [this.form.firstPersonId] : [this.form.firstPersonId, this.form.secondPersonId];
      const technicians = this.tableList.filter(item => filterIds.includes(item.userId));
      return {
        orderDeviceId: this.model.data.orderDeviceId,
        technicians,
      };
    },
  },
  created() { },
  mounted() {
    this.getTableList();
  },
};
</script>

<style>
</style>
